(function () {
  const el = window.UIDOM.el;
  const esc = window.UIDOM.esc;
  const RB = window.RB;
  const U = window.UIX;
  const pct = U.pct;
  const card = U.cardOf;
  const cardName = U.cardName;
  const get = RB.Api.get;
  const MENU_KEY = "riftbound-menu-cfg";
  const MIDDOT = " · ";

  const S = {
    fields: null,
    fieldId: null,
    field: null,
    rankFiles: null,
    rank: null,
    matrix: null,
    err: null,
    pipeline: null,
    loading: false,
    tab: "tier",
    selected: null,
  };

  function artImg(id, cls, sizes) {
    return U.artImg(id, cls, { sizes: sizes, lazy: false, animated: false });
  }

  const WR_BANDS = [
    [34, "#82372f", "#ffe0da"],
    [42, "#5c2b25", "#f7c4ba"],
    [47, "#38201c", "#f0b7ad"],
    [52, "#141c2b", "#93a4c0"],
    [57, "#163628", "#a9e0c4"],
    [64, "#1f5940", "#d5f3e4"],
    [101, "#2b7a56", "#eafff2"],
  ];

  function wrBand(p) {
    if (typeof p !== "number" || isNaN(p)) return null;
    const v = p * 100;
    for (const b of WR_BANDS) if (v <= b[0]) return { bg: b[1], fg: b[2] };
    return WR_BANDS[WR_BANDS.length - 1].slice(1);
  }

  function wrStyle(p) {
    const b = wrBand(p);
    return b ? "background:" + b.bg + ";color:" + b.fg : "";
  }

  function selectInViewer(id) {
    try {
      const raw = JSON.parse(localStorage.getItem(MENU_KEY) || "null") || {};
      if (!Array.isArray(raw.seats) || !raw.seats.length) raw.seats = [{}, {}];
      raw.seats[0] = Object.assign({}, raw.seats[0], { deck: id });
      localStorage.setItem(MENU_KEY, JSON.stringify(raw));
    } catch (e) { }
    location.href = "/deckbuilder";
  }

  function listLegend(id) {
    for (const l of (S.field && S.field.lists) || []) if (l.id === id) return l.legend;
    return null;
  }

  function listById(id) {
    for (const l of (S.field && S.field.lists) || []) if (l.id === id) return l;
    return null;
  }

  function rowByList(id) {
    for (const r of (S.rank && S.rank.rows) || []) if (r.list === id) return r;
    return null;
  }

  function championName(row) {
    const name = row && row.name || "";
    const i = name.indexOf(MIDDOT);
    return i >= 0 ? name.slice(0, i) : name;
  }

  function eventName(row) {
    const name = row && row.name || "";
    const i = name.indexOf(MIDDOT);
    return i >= 0 ? name.slice(i + MIDDOT.length) : "";
  }

  function domainPips(legendId) {
    const c = card(legendId);
    const wrap = el("span", "mgpips");
    for (const d of (c && c.domains) || []) {
      const pip = el("span", "mgpip");
      pip.title = d;
      pip.style.background = "var(--" + d + ", var(--dim))";
      wrap.appendChild(pip);
    }
    return wrap;
  }

  function goToDeck(listId) {
    S.tab = "deck";
    S.selected = listId;
    render();
  }

  function load() {
    S.loading = true;
    S.err = null;
    S.pipeline = null;
    return get("/api/meta/rank").then(function (files) {
      S.rankFiles = files;
      if (!files.length) {
        return Promise.all([
          get("/api/meta/fields").catch(function () { return []; }),
          get("/api/meta/matrix").catch(function () { return []; }),
        ]).then(function (both) {
          S.pipeline = { fields: both[0].length, matrices: both[1].length };
          throw new Error("no ranking yet");
        });
      }
      let want = files[0];
      for (const f of files) {
        if (S.fieldId && f.meta && f.meta.field === S.fieldId) { want = f; break; }
      }
      return get("/api/meta/rank/" + encodeURIComponent(want.file));
    }).then(function (rank) {
      S.rank = rank;
      S.fieldId = (rank.meta && rank.meta.field) || rank.field;
      const jobs = [get("/api/meta/field/" + encodeURIComponent(S.fieldId))];
      const mx = rank.meta && rank.meta.matrix ? String(rank.meta.matrix).split("/").pop() : null;
      jobs.push(mx ? get("/api/meta/matrix/" + encodeURIComponent(mx)).catch(function () { return null; }) : Promise.resolve(null));
      return Promise.all(jobs);
    }).then(function (both) {
      S.field = both[0];
      S.matrix = both[1];
      S.loading = false;
      if (!S.selected && S.rank && S.rank.rows && S.rank.rows.length) S.selected = S.rank.rows[0].list;
      render();
    }).catch(function (e) {
      S.loading = false;
      S.err = e.url ? e.url + " -> " + e.status : e.message;
      render();
    });
  }

  function healthPanel() {
    const box = el("div", "mgheal");
    const fit = S.rank.fit || {};
    const m = S.matrix;
    let stalls = null;
    if (m && m.d && m.n) {
      let d = 0, n = 0;
      for (let i = 0; i < m.n.length; i++) {
        for (let j = 0; j < m.n.length; j++) { n += m.n[i][j]; d += (m.d[i] && m.d[i][j]) || 0; }
      }
      if (n) stalls = d / n;
    }
    const onPlayGap = typeof S.rank.onPlayWinRate === "number" ? Math.abs(S.rank.onPlayWinRate - 0.5) : null;
    const transitive = fit.significantCells ? fit.significantMismatch / Math.max(1, fit.significantCells) : null;

    function grade(v, warnAt, badAt) {
      if (v === null || v === undefined || isNaN(v)) return "";
      return v > badAt ? "bad" : v > warnAt ? "warn" : "";
    }

    const items = [
      ["Games", fit.games ? String(fit.games) : "—", "", "decisive games behind the ratings"],
      ["On the play", pct(S.rank.onPlayWinRate), grade(onPlayGap, 0.05, 0.10),
        "seat-balanced by construction: the two orientations share a seed"],
      ["Unfinished", stalls === null ? "—" : pct(stalls, 2), grade(stalls, 0.05, 0.10),
        "games that hit the action cap and are excluded; a rate that varies by deck biases the table"],
      ["Rating fit", fit.excess === undefined ? "—" : (+fit.excess).toFixed(4), grade(fit.excess, 0.02, 0.05),
        "excess log loss over a per-matchup model — near zero means one rating per deck is a fair summary"],
      ["Upsets", fit.significantCells ? fit.significantMismatch + "/" + fit.significantCells : "—",
        grade(transitive, 0.10, 0.20), "clearly-decided matchups that fall on the wrong side of the rating"],
    ];
    for (const it of items) {
      const g = it[2];
      const tile = el("div", "mgtile" + (g ? " " + g : ""));
      const head = el("div", "mgtilehead");
      head.appendChild(el("span", "mslbl", esc(it[0])));
      head.appendChild(el("span", "mgdot", null));
      head.lastChild.style.background = g === "bad" ? "var(--crimson)" : g === "warn" ? "var(--warn)" : "var(--good)";
      tile.appendChild(head);
      tile.appendChild(el("div", "mgtilev" + (g ? " " + g : ""), esc(it[1])));
      tile.appendChild(el("div", "mgtilem", esc(it[3])));
      tile.title = it[3];
      box.appendChild(tile);
    }
    return { box: box, transitive: transitive };
  }

  function tierRow(row, idx) {
    const line = el("div", "mgrow" + (idx === 0 ? " lead" : ""));
    line.onclick = function () { goToDeck(row.list); };
    line.title = "Open " + (row.name || row.list);
    line.appendChild(el("span", "mgrank msnum", String(idx + 1)));
    const legend = listLegend(row.list);
    line.appendChild(artImg(legend, "mgface", "48px"));
    const name = el("span", "mgname");
    const nm1 = el("span", "mgnamen");
    nm1.appendChild(document.createTextNode(championName(row)));
    nm1.appendChild(el("span", "mgnamesep", "·"));
    const nm2 = el("span", null, esc(cardName(legend)));
    nm2.style.color = "var(--dim)";
    nm1.appendChild(nm2);
    name.appendChild(nm1);
    name.appendChild(el("span", "mgnamesub", esc(eventName(row) || row.name || row.list)));
    line.appendChild(name);
    line.appendChild(domainPips(legend));

    const minR = S.rank.rows[S.rank.rows.length - 1].rating - S.rank.rows[S.rank.rows.length - 1].se;
    const maxR = S.rank.rows[0].rating + S.rank.rows[0].se;
    const span = Math.max(1, maxR - minR);
    const rate = el("span", "mgrate");
    const ratev = el("span", "mgratev msnum", String(Math.round(row.rating)));
    rate.appendChild(ratev);
    const track = el("span", "mgratetk");
    const lo = ((row.rating - row.se - minR) / span) * 130;
    const wid = ((2 * row.se) / span) * 130;
    track.appendChild(el("span", "mgratewh", null));
    track.lastChild.style.left = lo.toFixed(1) + "px";
    track.lastChild.style.width = wid.toFixed(1) + "px";
    track.appendChild(el("span", "mgratedt", null));
    track.lastChild.style.left = (lo + wid / 2).toFixed(1) + "px";
    rate.appendChild(track);
    line.appendChild(rate);

    const wr = el("span", "mgwr msnum", pct(row.fieldWinrate, 0));
    wr.setAttribute("style", wrStyle(row.fieldWinrate));
    wr.title = "field-weighted win rate";
    line.appendChild(wr);

    const maxShare = S.rank.rows.reduce(function (m, r) { return Math.max(m, r.share || 0); }, 0.0001);
    const shr = el("span", "mgshr");
    const shrtk = el("span", "mgshrtk");
    shrtk.appendChild(el("span", "mgshrfl", null));
    shrtk.lastChild.style.width = (100 * (row.share || 0) / maxShare).toFixed(1) + "%";
    shr.appendChild(shrtk);
    shr.appendChild(el("span", "mgshrv msnum", pct(row.share)));
    shr.title = "share of the field";
    line.appendChild(shr);
    return line;
  }

  function colHead() {
    const minR = S.rank.rows[S.rank.rows.length - 1].rating - S.rank.rows[S.rank.rows.length - 1].se;
    const maxR = S.rank.rows[0].rating + S.rank.rows[0].se;
    const span = Math.max(1, maxR - minR);
    const row = el("div", "mgcolhead");
    row.appendChild(el("span", "mslbl mgch-rank", null));
    row.appendChild(el("span", "mslbl mgch-face", null));
    row.appendChild(el("span", "mslbl mgch-nm", "Deck"));
    row.appendChild(el("span", "mslbl mgch-pip", null));
    const rate = el("span", "mgch-rate");
    rate.appendChild(el("span", "mslbl", "Rating ±1 SE"));
    const ruler = el("span", "mgruler");
    for (const tick of [1200, 1400, 1600]) {
      if (tick < minR - 20 || tick > maxR + 20) continue;
      const x = ((tick - minR) / span) * 130;
      const lbl = el("span", null, String(tick));
      lbl.style.left = x.toFixed(1) + "px";
      ruler.appendChild(lbl);
      const tickmark = el("i", null, null);
      tickmark.style.left = x.toFixed(1) + "px";
      ruler.appendChild(tickmark);
    }
    rate.appendChild(ruler);
    row.appendChild(rate);
    row.appendChild(el("span", "mslbl mgch-wr", "Field WR"));
    row.appendChild(el("span", "mslbl mgch-shr", "Share"));
    return row;
  }

  function tierPanel() {
    const box = el("div", null);
    box.appendChild(colHead());
    const rows = S.rank.rows || [];
    let shown = null;
    rows.forEach(function (row, idx) {
      if (row.tier !== shown) {
        shown = row.tier;
        const head = el("div", "mgtiergrp");
        head.appendChild(el("span", "mgtierl disp", esc(row.tier)));
        head.appendChild(el("span", "mgtierrule", null));
        const count = rows.filter(function (r) { return r.tier === row.tier; }).length;
        head.appendChild(el("span", "mslbl f", count + (count === 1 ? " deck" : " decks")));
        box.appendChild(head);
      }
      box.appendChild(tierRow(row, idx));
    });
    return box;
  }

  function compositionPanel() {
    const rows = (S.rank.rows || []).slice().sort(function (a, b) { return (b.share || 0) - (a.share || 0); });
    const shown = rows.slice(0, 8);
    const rest = rows.slice(8);
    const maxShare = shown.length ? shown[0].share || 0.0001 : 0.0001;
    const box = el("div", "mgpanel");
    const h = el("div", "mgpanelh");
    h.appendChild(el("h3", null, "Field composition"));
    h.appendChild(el("span", "mslbl f", "share of entries"));
    box.appendChild(h);
    const comp = el("div", "mgcomp");
    for (const row of shown) {
      const legend = listLegend(row.list);
      const r = el("div", "mgcomprow");
      r.onclick = function () { goToDeck(row.list); };
      r.appendChild(artImg(legend, "mgcompface", "32px"));
      r.appendChild(el("span", "mgcompnm", esc(championName(row))));
      r.appendChild(el("span", "mgcomptag", esc(row.tier)));
      const tk = el("span", "mgcomptk");
      tk.appendChild(el("span", "mgcompfl", null));
      tk.lastChild.style.width = (100 * (row.share || 0) / maxShare).toFixed(1) + "%";
      r.appendChild(tk);
      r.appendChild(el("span", "mgcompv msnum", pct(row.share)));
      comp.appendChild(r);
    }
    box.appendChild(comp);
    if (rest.length) {
      const restShare = rest.reduce(function (a, r) { return a + (r.share || 0); }, 0);
      box.appendChild(el("div", "mgpanelnote",
        esc(rest.length + " more deck" + (rest.length === 1 ? "" : "s") + " at " + pct(shown[shown.length - 1].share, 1) +
          " or less — together " + pct(restShare, 0) + " of the field.")));
    }
    return box;
  }

  function scatterPanel() {
    const rows = S.rank.rows || [];
    const box = el("div", "mgpanel");
    const h = el("div", "mgpanelh");
    h.appendChild(el("h3", null, "Share against rating"));
    h.appendChild(el("span", "mslbl f", "1 dot = 1 deck"));
    box.appendChild(h);
    if (rows.length < 2) {
      box.appendChild(el("div", "mgpanelnote", "Not enough decks to plot."));
      return box;
    }
    const W = 320, H = 200, PAD_L = 34, PAD_B = 22, PAD_T = 14;
    const minR = Math.min.apply(null, rows.map(function (r) { return r.rating; }));
    const maxR = Math.max.apply(null, rows.map(function (r) { return r.rating; }));
    const maxShare = Math.max.apply(null, rows.map(function (r) { return r.share || 0; }));
    const x = function (share) { return PAD_L + (share / (maxShare * 1.08 || 1)) * (W - PAD_L - 6); };
    const y = function (rating) { return PAD_T + (1 - (rating - minR) / Math.max(1, maxR - minR)) * (H - PAD_T - PAD_B); };
    let svg = "<svg width=\"" + W + "\" height=\"" + H + "\" viewBox=\"0 0 " + W + " " + H + "\" role=\"img\" aria-label=\"Field share against rating\">";
    const rTicks = 4;
    for (let i = 0; i <= rTicks; i++) {
      const rv = minR + (maxR - minR) * (i / rTicks);
      const yy = y(rv);
      svg += "<line x1=\"" + PAD_L + "\" y1=\"" + yy.toFixed(1) + "\" x2=\"" + (W - 6) + "\" y2=\"" + yy.toFixed(1) + "\" stroke=\"#16223a\" stroke-width=\"1\"/>";
      svg += "<text x=\"" + (PAD_L - 6) + "\" y=\"" + (yy + 3).toFixed(1) + "\" text-anchor=\"end\" fill=\"#55688a\" font-size=\"8\" font-family=\"Consolas, monospace\">" + Math.round(rv) + "</text>";
    }
    const topRated = rows[0];
    const topShare = rows.slice().sort(function (a, b) { return (b.share || 0) - (a.share || 0); })[0];
    for (const row of rows) {
      const cx = x(row.share || 0), cy = y(row.rating);
      const notable = row === topRated || row === topShare;
      svg += "<circle cx=\"" + cx.toFixed(1) + "\" cy=\"" + cy.toFixed(1) + "\" r=\"4\" fill=\"" +
        (notable ? "#f0c46a" : "rgba(240,196,106,.42)") + "\" stroke=\"#0a101d\" stroke-width=\"2\"/>";
      if (notable) {
        svg += "<text x=\"" + (cx + (cx > W - 60 ? -10 : 10)).toFixed(1) + "\" y=\"" + (cy - 6).toFixed(1) + "\" text-anchor=\"" +
          (cx > W - 60 ? "end" : "start") + "\" fill=\"#e8eef9\" font-size=\"10\">" + esc(championName(row)) + "</text>";
      }
    }
    svg += "<text x=\"" + PAD_L + "\" y=\"" + (H - 4) + "\" fill=\"#55688a\" font-size=\"8\" letter-spacing=\"1.6\">SHARE OF FIELD →</text>";
    svg += "</svg>";
    const wrap = document.createElement("div");
    wrap.innerHTML = svg;
    box.appendChild(wrap.firstChild);
    box.appendChild(el("div", "mgpanelnote",
      "The field's weight and its strength are different things — hover a tier row to see how far apart they sit."));
    return box;
  }

  function methodPanel() {
    const box = el("div", "mgpanel");
    box.appendChild(el("div", "mgpanelh", "<h3>How this is built</h3>"));
    const meth = el("div", "mgmeth");
    const rows = [
      ["Rating", "Bradley-Terry maximum likelihood over the matchup matrix, anchored at " +
        (S.rank.anchor || 1500) + " with a prior of " + (S.rank.prior === undefined ? 2 : S.rank.prior) + " games per cell"],
      ["Tier break", "where the gap between neighbours exceeds " + (S.rank.breakZ || 4) + " standard errors of that gap"],
      ["Sampling", (S.rank.gamesPerCell || S.rank.games || "—") + " games per ordered pair, seat-mirrored on a shared seed"],
      ["Run", esc((S.rank.pilot || "") + MIDDOT + String((S.rank.meta && S.rank.meta.createdAt) || "").slice(0, 10))],
    ];
    for (const r of rows) {
      const line = el("div", "mgmethrow");
      line.appendChild(el("span", "mslbl f", esc(r[0])));
      line.appendChild(el("span", null, r[1]));
      meth.appendChild(line);
    }
    box.appendChild(meth);
    return box;
  }

  function tierTab() {
    const wrap = document.createDocumentFragment();
    const health = healthPanel();
    wrap.appendChild(health.box);
    if (health.transitive !== null && health.transitive > 0.15) {
      const alert = el("div", "mgalert");
      alert.textContent = "⚠ this field is not well described by one number per deck — read the matrix, not the tiers.";
      wrap.appendChild(alert);
    }
    const cols = el("div", "mgcols");
    const main = el("div", "mgmain");
    const head = el("div", "mghead");
    head.appendChild(el("h2", null, "Tier list"));
    head.appendChild(el("span", "mslbl f", (S.rank.rows || []).length + " decks · ordered by rating"));
    main.appendChild(head);
    main.appendChild(tierPanel());
    cols.appendChild(main);
    const rail = el("div", "mgrail");
    rail.appendChild(compositionPanel());
    rail.appendChild(scatterPanel());
    rail.appendChild(methodPanel());
    cols.appendChild(rail);
    wrap.appendChild(cols);
    return wrap;
  }

  function matrixTab() {
    const wrap = document.createDocumentFragment();
    const m = S.matrix;
    const head = el("div", "mghead");
    head.appendChild(el("h2", null, "Matchup matrix"));
    head.appendChild(el("span", "mslbl f", "row beats column · ordered by rating"));
    head.appendChild(el("span", "sp", null));
    const scale = el("div", "mgscale");
    scale.appendChild(el("span", "mslbl f", "Row loses"));
    const scalew = el("span", "mgscalew");
    const bar = el("span", "mgscaleb");
    for (const b of WR_BANDS) { const sw = el("span", null, null); sw.style.background = b[1]; bar.appendChild(sw); }
    scalew.appendChild(bar);
    const ticks = el("span", "mgscalet");
    [34, 42, 47, 52, 57, 64].forEach(function (t, i) { const s = el("span", null, String(t)); s.style.left = (i * 26 + 26) + "px"; ticks.appendChild(s); });
    scalew.appendChild(ticks);
    scale.appendChild(scalew);
    scale.appendChild(el("span", "mslbl f", "Row wins"));
    head.appendChild(scale);
    wrap.appendChild(head);

    if (!m) {
      wrap.appendChild(el("div", "msempty", "The matrix behind this ranking is not on disk any more."));
      return wrap;
    }

    const order = (S.rank.rows || []).map(function (r) { return m.lists.indexOf(r.list); }).filter(function (i) { return i >= 0; });

    const scroll = document.createElement("div");
    scroll.style.overflowX = "auto";
    const table = el("table", "mgmx");
    const thead = document.createElement("thead");
    const htr = document.createElement("tr");
    htr.appendChild(el("th", "mgmxrh", null));
    htr.appendChild(el("th", "mgmxrt", null));
    for (const j of order) {
      const th = document.createElement("th");
      th.className = "mgmxch";
      const legend = m.lists[j] && listLegend(m.lists[j]);
      const inner = el("span", "mgmxchin");
      inner.onclick = function () { goToDeck(m.lists[j]); };
      const row = rowByList(m.lists[j]);
      inner.appendChild(el("span", "mgmxchn", esc(row ? championName(row) : m.lists[j])));
      inner.appendChild(artImg(legend, "mgmxchip", "32px"));
      th.appendChild(inner);
      htr.appendChild(th);
    }
    thead.appendChild(htr);
    table.appendChild(thead);

    const tbody = document.createElement("tbody");
    let prevTier = null;
    for (const i of order) {
      const row = rowByList(m.lists[i]);
      const tr = document.createElement("tr");
      if (prevTier !== null && row && row.tier !== prevTier) tr.className = "mgmxsep";
      if (row) prevTier = row.tier;
      const th = document.createElement("th");
      th.className = "mgmxrh";
      th.onclick = function () { goToDeck(m.lists[i]); };
      const rhin = el("span", "mgmxrhin");
      const legend = listLegend(m.lists[i]);
      rhin.appendChild(artImg(legend, "mgmxrf", "32px"));
      rhin.appendChild(el("span", "mgmxrn", esc(row ? championName(row) : m.lists[i])));
      rhin.appendChild(el("span", "mslbl f", esc((row && row.tier) || "")));
      th.appendChild(rhin);
      tr.appendChild(th);
      const rt = el("td", "mgmxrt", row ? String(Math.round(row.rating)) : "—");
      tr.appendChild(rt);
      for (const j of order) {
        tr.appendChild(U.matrixCell(m, i, j, "mgmxc" + (i === j ? " mgmxdiag" : ""), function (p, n, diag) {
          return diag ? null : wrStyle(p);
        }, listLegend));
      }
      tbody.appendChild(tr);
    }
    table.appendChild(tbody);
    scroll.appendChild(table);
    wrap.appendChild(scroll);

    const foot = el("div", "mgfoot");
    const k1 = el("span", "mgkey");
    k1.appendChild(el("span", "mgkeysw", null));
    k1.lastChild.style.background = "#0b111d";
    k1.appendChild(document.createTextNode("mirror, not played"));
    foot.appendChild(k1);
    const k2 = el("span", "mgkey");
    k2.appendChild(el("span", "mgkeysw", null));
    k2.lastChild.setAttribute("style", "box-shadow: inset 0 0 0 1px rgba(6,10,18,.55), inset 0 1px 0 var(--gold), inset 0 -1px 0 var(--gold); background:#141c2b");
    k2.appendChild(document.createTextNode("the row under the cursor"));
    foot.appendChild(k2);
    const k3 = el("span", "mgkey");
    k3.appendChild(el("span", "mgkeysw", null));
    k3.lastChild.setAttribute("style", "border-top: 1px solid var(--goldline); background: transparent");
    k3.appendChild(document.createTextNode("tier break"));
    foot.appendChild(k3);
    const note = el("span", "mslbl f", "Every cell is " + (S.rank.gamesPerCell || S.rank.games || "—") +
      " games, seats mirrored. Hovering a cell gives its 95% interval.");
    note.style.marginLeft = "auto";
    foot.appendChild(note);
    wrap.appendChild(foot);
    return wrap;
  }

  function deckTab() {
    const wrap = document.createDocumentFragment();
    const row = rowByList(S.selected);
    if (!row) {
      wrap.appendChild(el("div", "msempty", "Pick a deck from the tier list or matchup matrix."));
      return wrap;
    }
    const list = listById(row.list);
    const legend = listLegend(row.list);
    const idx = S.rank.rows.indexOf(row);

    const crumb = el("div", "mgcrumb");
    const back = el("a", null, "◀ Tier list");
    back.onclick = function (e) { e.preventDefault(); S.tab = "tier"; render(); };
    crumb.appendChild(back);
    crumb.appendChild(el("span", null, "/"));
    crumb.appendChild(el("span", null, esc(row.name || row.list)));
    wrap.appendChild(crumb);

    const cols = el("div", "mgdcols");
    const left = el("div", "mgdleft");
    const hero = el("div", "mghero");
    hero.appendChild(artImg(legend, "mgheroart", "160px"));
    const body = el("div", "mgherobody");
    const badge = el("span", "mgbadge");
    badge.appendChild(el("span", "mgbadget disp", esc(row.tier)));
    badge.appendChild(el("span", "mgbadgen", "#" + (idx + 1) + " of " + S.rank.rows.length));
    body.appendChild(badge);
    body.appendChild(el("div", "mgheroname", esc(championName(row))));
    const herolg = el("div", "mgherolg");
    herolg.appendChild(document.createTextNode(cardName(legend)));
    herolg.appendChild(domainPips(legend));
    body.appendChild(herolg);
    body.appendChild(el("div", "mgheroev", esc(eventName(row) || row.name || "")));
    hero.appendChild(body);
    left.appendChild(hero);

    const stats = el("div", "mgstats2");
    function stat(label, valueHtml, plain) {
      const s = el("div", "mgstat2");
      s.appendChild(el("span", "mslbl", esc(label)));
      s.appendChild(el("span", "mgstatv" + (plain ? " plain" : ""), valueHtml));
      stats.appendChild(s);
    }
    stat("Rating", esc(Math.round(row.rating)) + "<em>±" + Math.round(row.se) + "</em>");
    stat("Field win rate", esc(pct(row.fieldWinrate)));
    stat("Share of field", esc(pct(row.share)), true);
    stat("Games", esc(String(row.games || 0)), true);
    left.appendChild(stats);

    const lst = el("div", "mglst");
    const champCard = list && card(list.champion);
    function lrow(label, value) {
      const r = el("div", "mglstrow");
      r.appendChild(el("span", "mslbl f", esc(label)));
      r.appendChild(el("span", null, esc(value)));
      lst.appendChild(r);
    }
    lrow("Champion", champCard ? champCard.name : "—");
    lrow("Legend", cardName(legend));
    lrow("Battlefields", list && list.battlefields ? String(list.battlefields.length) : "—");
    left.appendChild(lst);

    const acts = el("div", "mgacts");
    const open = el("a", "btn gold", "Open the list");
    open.href = "/deckbuilder";
    open.onclick = function (e) { e.preventDefault(); selectInViewer(row.list); };
    acts.appendChild(open);
    const spar = el("a", "btn ghost", "Spar against it");
    spar.href = "/trainer";
    acts.appendChild(spar);
    left.appendChild(acts);
    cols.appendChild(left);

    const right = el("div", "mgdright");
    const head = el("div", "mghead");
    head.appendChild(el("h2", null, "Matchup spread"));
    head.appendChild(el("span", "mslbl f",
      championName(row) + " against the field · bar is the win rate, the pale band the 95% interval · hatched where that interval still spans 50%"));
    right.appendChild(head);

    const spread = el("div", "mgspread");
    const axis = el("div", "mgaxis");
    [[25, "25%"], [50, "50%"], [75, "75%"]].forEach(function (t) {
      const lbl = el("span", null, t[1]);
      lbl.style.left = t[0] + "%";
      axis.appendChild(lbl);
      const tick = el("i", null, null);
      tick.style.left = t[0] + "%";
      axis.appendChild(tick);
    });
    spread.appendChild(axis);

    const m = S.matrix;
    if (!m) {
      spread.appendChild(el("div", "msempty", "No matrix on disk for this ranking."));
    } else {
      const i = m.lists.indexOf(row.list);
      const others = S.rank.rows.filter(function (r) { return r.list !== row.list; }).map(function (r) {
        const j = m.lists.indexOf(r.list);
        const p = i >= 0 && j >= 0 ? m.wins[i][j] : null;
        const lo = i >= 0 && j >= 0 && m.lo ? m.lo[i][j] : null;
        const hi = i >= 0 && j >= 0 && m.hi ? m.hi[i][j] : null;
        const n = i >= 0 && j >= 0 && m.n ? m.n[i][j] : null;
        return { row: r, p: p, lo: lo, hi: hi, n: n };
      }).filter(function (o) { return typeof o.p === "number"; })
        .sort(function (a, b) { return b.p - a.p; });
      for (const o of others) {
        const spans50 = typeof o.lo === "number" && o.lo < 0.5 && o.hi > 0.5;
        const srow = el("div", "mgsrow");
        srow.onclick = function () { goToDeck(o.row.list); };
        srow.appendChild(artImg(listLegend(o.row.list), "mgsface", "24px"));
        srow.appendChild(el("span", "mgsnm", esc(championName(o.row))));
        const sbar = el("span", "mgsbar");
        const v = o.p * 100, lo = v - 50, w = Math.abs(lo);
        const fill = el("span", "mgsfill" + (spans50 ? " thin" : ""));
        fill.style.left = Math.min(50, v) + "%";
        fill.style.width = w + "%";
        fill.style.background = "var(--good)";
        fill.style.opacity = ".85";
        sbar.appendChild(fill);
        if (typeof o.lo === "number") {
          const ci = el("span", "mgsci");
          ci.style.left = (o.lo * 100) + "%";
          ci.style.width = ((o.hi - o.lo) * 100) + "%";
          sbar.appendChild(ci);
        }
        srow.appendChild(sbar);
        const sv = el("span", "mgsv msnum", pct(o.p, 0));
        sv.style.color = spans50 ? "var(--dim)" : "var(--good)";
        srow.appendChild(sv);
        srow.appendChild(el("span", "mgsn msnum", o.n ? String(o.n) : "—"));
        spread.appendChild(srow);
      }
    }
    right.appendChild(spread);
    cols.appendChild(right);
    wrap.appendChild(cols);
    return wrap;
  }

  function emptyPanel() {
    const box = el("div", "mgempty");
    box.appendChild(el("div", "mgemptyh", "NOTHING RANKED YET"));
    box.appendChild(el("div", "mgemptyp",
      "A tier list is the last step of three. Play through the field, the matrix, and the ranking job in the trainer lab to get one."));
    const pipe = el("div", "mgpipe");
    const p = S.pipeline || { fields: 0, matrices: 0 };
    const now = p.fields === 0 ? 0 : p.matrices === 0 ? 1 : 2;
    const steps = [
      ["Field", p.fields ? p.fields + (p.fields === 1 ? " field" : " fields") : "none yet"],
      ["Matrix", p.matrices ? p.matrices + " run" + (p.matrices === 1 ? "" : "s") : "not run"],
      ["Ranking", "waiting"],
    ];
    steps.forEach(function (s, i) {
      const cls = i < now ? "done" : i === now ? "now" : "";
      const step = el("div", "mgstep" + (cls ? " " + cls : ""));
      step.appendChild(el("span", "mgstepd", String(i + 1)));
      step.appendChild(el("span", "mgstepn", esc(s[0])));
      step.appendChild(el("span", "mgsteps", esc(s[1])));
      pipe.appendChild(step);
      if (i < steps.length - 1) pipe.appendChild(el("span", "mgpipel", null));
    });
    box.appendChild(pipe);
    const goLab = el("a", "btn gold", "Open the lab");
    goLab.href = "/trainer";
    goLab.style.height = "32px";
    goLab.style.padding = "0 18px";
    box.appendChild(goLab);
    return box;
  }

  function section(title, sub) {
    return U.sectionHead("mghead", title, sub);
  }

  function tabsBar() {
    const nav = el("div", "mgtabs");
    [["tier", "Tier list"], ["matrix", "Matchups"], ["deck", "Deck"]].forEach(function (t) {
      const tab = el("button", "mgtab" + (S.tab === t[0] ? " on" : ""), esc(t[1]));
      tab.type = "button";
      tab.onclick = function () { S.tab = t[0]; render(); };
      nav.appendChild(tab);
    });
    const meta = el("div", "mgtabmeta");
    const field = S.field;
    if (field) {
      meta.appendChild(el("span", "mslbl f", "Field"));
      meta.appendChild(el("span", "mgtabmetav", esc(field.name || field.id)));
      meta.appendChild(el("span", "mgsep", null));
      meta.appendChild(el("span", "mslbl f", "Window"));
      const win = field.window ? field.window.from + " → " + field.window.to : "—";
      meta.appendChild(el("span", "mgtabmetav dim msnum", esc(win)));
      meta.appendChild(el("span", "mgsep", null));
      meta.appendChild(el("span", "mslbl f", "Pilot"));
      meta.appendChild(el("span", "mgtabmetav dim", esc((S.rank.meta && S.rank.meta.pilot) || S.rank.pilot || "—")));
    }
    nav.appendChild(meta);
    return nav;
  }

  function render() {
    const root = document.getElementById("app");
    root.innerHTML = "";
    root.className = "";
    const shell = U.screenShell("menuscreen", "METAGAME", esc((S.field && S.field.format) || "loading…"));
    const wrap = shell.wrap;
    const acts = shell.acts;
    if (S.rank) {
      const decks = el("div", "mscnt");
      decks.appendChild(el("span", "mslbl", "Decks"));
      decks.appendChild(el("span", "mscntn", String((S.rank.rows || []).length)));
      acts.appendChild(decks);
      const games = el("div", "mscnt");
      games.appendChild(el("span", "mslbl", "Games"));
      games.appendChild(el("span", "mscntn", String((S.rank.fit && S.rank.fit.games) || 0)));
      acts.appendChild(games);
    }
    const lab = el("button", "btn ghost", "Lab");
    lab.title = "Run a new matrix or ranking";
    lab.onclick = function () { location.href = "/trainer"; };
    acts.appendChild(lab);

    if (S.rank) wrap.appendChild(tabsBar());

    const body = el("div", "mgbody");
    if (S.err === "no ranking yet") {
      body.appendChild(section("Metagame", null));
      body.appendChild(emptyPanel());
    } else if (S.err) {
      body.appendChild(el("div", "deckerr", esc(S.err)));
    } else if (!S.rank) {
      body.appendChild(el("div", "msempty", "Loading the ranking…"));
    } else if (S.tab === "matrix") {
      body.appendChild(matrixTab());
    } else if (S.tab === "deck") {
      body.appendChild(deckTab());
    } else {
      body.appendChild(tierTab());
    }
    wrap.appendChild(body);
    root.appendChild(wrap);
  }

  window.RB.Metagame = {
    boot() {
      render();
      load();
    },
  };
})();
